<form [formGroup]="generatorForm">
	<app-text-input-with-label
		[control]="generatorForm.controls['name']"
		[maxLength]="charLimit"
		placeholder="Enter here ..."
		[inputLabel]="titleName"
	></app-text-input-with-label>
	<div class="d-part input">
		<div class="input-box">
			<div class="label dropdown">
				<label>Output Tone</label>
				<app-tooltip text="You can type your own Tone"></app-tooltip>
			</div>
			<app-custom-drpdown-op1
				[data]="outputTone"
				(selectionChange)="changeToneSource($event)"
				[useCustom]="true"
				[dropdownFormControl]="generatorForm?.get('outputTone')"
				[placeHolder]="'Select/Enter new'"
				[searchEnable]="true"
				[noError]="true"
			></app-custom-drpdown-op1>
			<div class="error-field">
				<span *ngIf="!generatorForm.controls.outputTone.valid">This field is required</span>
			</div>
		</div>
	</div>
	<div class="d-part input showMobile">
		<div class="input-box">
			<div class="label dropdown">
				<label>No of Outputs</label>
			</div>
			<app-custom-drpdown-op1
				[data]="maxOutputArray"
				[dropdownFormControl]="generatorForm?.get('numOutputs')"
				[useCustom]="false"
				[defaultSelectedValue]="{ name: '3 Outputs', value: 3 }"
				[hideClearButton]="true"
				[placeHolder]="'Output'"
			></app-custom-drpdown-op1>
		</div>
	</div>
	<div class="input toggle">
		<div class="d-flex">
			<div class="label">
				<label>Advance Option</label>
			</div>
			<app-tooltip text="Describe more about your topic for better results" style="margin-top: 2px;"></app-tooltip>
		</div>
		<app-switch (toggle)="checkToggleValue($event)" [value]="advanceOptions"></app-switch>
	</div>
	<div *ngIf="advanceOptions" class="advance">
		<div class="input spec" *ngIf="blogKeywords && (selectedTemplate.platform == 'pinterest' || selectedTemplate.platform == 'facebook')">
			<div class="d-flex align-items-center title">
				<div class="label">
					<label>Keywords</label>
				</div>
				<app-tooltip text="Add keywords to generate SEO-optimized content" style="margin-top: 2px;"></app-tooltip>
			</div>
			<app-input-with-add-more
				[inputPlaceholders]="keywordPlaceHolders"
				[control]="generatorForm.get('keywords')"
				errorMessage="Please fill this field."
				[maxInput]="5"
			></app-input-with-add-more>
		</div>
		<div class="input">
			<div class="input-lang">
				<div class="label dropdown">
					<label>Output Language (Optional)</label>
				</div>
				<app-custom-drpdown-op1
					[data]="outputLang"
					(selectionChange)="changeLangSource($event)"
					[dropdownFormControl]="generatorForm?.get('outputLang')"
					[useCustom]="false"
					[placeHolder]="'Select Language'"
					[searchEnable]="true"
				></app-custom-drpdown-op1>
			</div>
		</div>
	</div>
</form>
